import { Component } from "@angular/core";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PacientesService } from '../services/pacientes.service';
import { stringify } from 'querystring';
@Component({
    selector:"App-editar",
    templateUrl : './../views/editor.component.html',
    styleUrls: ['./../css/formulariopaciente.component.css'],
    providers: [PacientesService]
})

export class EditPacientesComponent{

    public titulo: string;
    public paciente: any;
    public consultas: any;
    public ultimaConsulta: any;
    public consultation = {
        patient: {full_name:'',rut:'',address:'',birthdate:'',occupation:'',phone:''},
        id:'',
        value:'',
        date:'',
        recipe: {
          near: {
            od: {cli:'',eje:'',esf:''},
            oi: {cli:'',eje:'',esf:''}
          },
          far: {
            od: {cli:'',eje:'',esf:''},
            oi: {cli:'',eje:'',esf:''}
          }
        },doctor:'',
        laboratory:'',
        lens_type:'',
        design: [],
        keratometry: {
          od: {a:'',b:''},
          oi: {a:'',b:''}
        },
        observations:''
      };

    constructor(
        private _pacientesEditService : PacientesService,
        private _activatedRoute : ActivatedRoute,
        private _router : Router,
        private _route: ActivatedRoute
    ){
        this.titulo = "Editar Paciente";
        
        
    }
    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.getPaciente();
        
    }   
    getPaciente() {
        this._route.params.forEach((params: Params) => {
            const id = params.id;
              this._pacientesEditService.getPaciente(id).subscribe(
                response => {
                      this.paciente = response.request.patient;
/*
<<<<<<< HEAD
*/
                  this.consultation = response.request.consultations[response.request.consultations.length - 1];
                  this.consultation.patient = response.request.patient;
                 
                      if (!this.consultation.design) {
                        this.consultation.design = []
                        this.consultation.design[0] = '';
                        this.consultation.design[1] = '';
                        this.consultation.design[2] = '';
                      }
                      if (!this.consultation.recipe) {
                         this.consultation.recipe = {
                          near: {
                            od: {cli:'',eje:'',esf:''},
                            oi: {cli:'',eje:'',esf:''}
                          },
                          far: {
                            od: {cli:'',eje:'',esf:''},
                            oi: {cli:'',eje:'',esf:''}
                          }
                        };
                      }
                      if (!this.consultation.keratometry){
                        this.consultation.keratometry = {
                          od: {a:'',b:''},
                          oi: {a:'',b:''}
                        };
                      }
                
                },
                error => {
                    console.log(error as any);
                }
            );
        });
  
    }
    onSubmit(){
      console.log(this.consultation);

      console.log(this.consultation);
      this._pacientesEditService.addPaciente(this.consultation).subscribe(
        response => {
          console.log(response);
          alert('Paciente modificado con exito');
          this._router.navigate(['/detalle',this.paciente.id]);
        },
        error => {
          console.log( error as any);
          alert('Intente de nuevo algo salio mal revise si todos los campos son correctos');

        });
    }
};
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/